import * as React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import LeftArrow from "../assets/arrows/arrow_back_ios_FILL0_wght400_GRAD0_opsz24.png";
import RightArrow from "../assets/arrows/arrow_forward_ios_FILL0_wght400_GRAD0_opsz24.png";
// import LeftArrow from "../assets/arrows/chevron-left.svg";
// import RightArrow from "../assets/arrows/chevron-right.svg";
// import "./styles.css";

export default function SlideShow(props: {
  thumbnail: string[];
  // setIsModalOpen: Function;
}) {
  const { thumbnail } = props;

  const SlickArrowLeft = ({ ...props }) => (
    <img
      src={LeftArrow}
      alt="prevArrow"
      {...props}
      style={{
        transform: "scale(2)",
        color: "red",
      }}
    />
  );

  const SlickArrowRight = ({ ...props }) => (
    <div>
      <img
        src={RightArrow}
        alt="nextArrow"
        {...props}
        style={{
          transform: "scale(2)",
        }}
      />
    </div>
  );

  const settings = {
    dots: true,
    dotsClass: "slick-dots slick-thumb",
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: <SlickArrowLeft />,
    nextArrow: <SlickArrowRight />,
  };

  return (
    <div
      style={{
        backgroundColor: "white",
        // position: "absolute",
        // top: "0",
        // left: "0",
        width: "650px",
        height: "auto",
        margin: "auto",
        // borderRadius: "15px",
        // padding: "5px",
        // marginTop: "20px",
      }}
    >
      <Slider {...settings}>
        {thumbnail &&
          thumbnail.map((each, index) => {
            console.log("each", each);
            return (
              <div key={index}>
                <img
                  src={each}
                  alt="slideshow"
                  style={{
                    display: "block",
                    width: "100%",
                    height: "auto",
                    // borderRadius: "15px",
                  }}
                />
              </div>
            );
          })}
      </Slider>
    </div>
  );
}
